document.addEventListener('DOMContentLoaded', (event) => {

function changeTab(tab_wrap) {
  tab_wrap.find('.tab-link').on('click', function () {
    tab_wrap.find('.tab-link').removeClass('active');
    tab_wrap.find('.infographic-content ').removeClass('active');
    $(this).addClass('active');
    var targetEl = $(this).data('target');
    tab_wrap.find('.infographic-content[data-target="' + targetEl + '"] ').addClass('active');
  });
}
changeTab($('.infographic-frame'));
changeTab($('.infographic-desk'));
function tabletopsSliders(){
  $('.section-tabletops .tabletops-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    asNavFor: '.tabletops-description-slider'
  });

  
  $('.section-tabletops .tabletops-description-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    asNavFor: '.tabletops-slider',
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: true
        }
      }
    ]
  });
};
tabletopsSliders();

function testimonialsSlider() {
  var slider = $(".page-block.active").find('.testimonials-slider');
  var slidesCount
  var progressBar = $(".page-block.active").find('.progress-bar');
  slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var calc = ((nextSlide+1) / (slick.slideCount)) * 100;
    progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc);
  });
  slider.on('init', function (event, slick) {
    slidesCount = slick.slideCount;
    var startCalc = (1 / (slidesCount)) * 100;
    progressBar
      .css('background-size', startCalc + '% 100%')
      .attr('aria-valuenow', startCalc);
    if (slidesCount < 10) {
      $('.count').text('0' + slidesCount);
    } else {
      $('.count').text(slidesCount);
    }
  });
  slider .slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true
  });
};
testimonialsSlider();

function compareSlider() { 
   var slider = $('.compare-slider');
  if ($(window).width() <= 1100) {
    var slidesCount = 0;
    var progressBar = $('.swiper-scrollbar');

    if(!slider.hasClass('slick-initialized')) {
    slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var calc = ((nextSlide+1) / slidesCount) * 100;
      progressBar
        .css('background-size', calc + '% 100%')
        .attr('aria-valuenow', calc);
    });
    slider.on('init', function (event, slick) {
      var startCalc = (1 / slidesCount) * 100;
      progressBar
        .css('background-size', startCalc + '% 100%')
        .attr('aria-valuenow', startCalc);
      if (slidesCount < 10) {
        $('.count').text('0' + slidesCount);
      } else {
        $('.count').text(slidesCount);
      }
    });
    slider.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: false,
      dots: true,
      customPaging : function(slider, i) {
        var thumb = $(slider.$slides[i]).data();
        slidesCount = (i + 1);
        return '<a class="dot">'+(i+1)+'</a>';
      },
      arrows: false,
      responsive: [
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }
  } else {
    if(slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
    }
  }
}
compareSlider();

activeTab();

function checkSliders(type){
  if ($('.section-image .section-image-wrapper').hasClass('slick-slider')) {
    $('.section-image .section-image-wrapper').slick('unslick');
  }
  if ($('.slider-products-image').hasClass('slick-slider')) {
    $('.slider-products-image').slick('unslick');
  }
  if ($(".page-block.active").find('.section-tabletops .tabletops-slider').hasClass('slick-slider')) {
    $(".page-block.active").find('.section-tabletops .tabletops-slider').slick('unslick');
  }
  if ($('.section-tabletops .tabletops-description-slider').hasClass('slick-slider')) {
    $('.section-tabletops .tabletops-description-slider').slick('unslick');
  }
  $('.testimonials-slider').each(function () {
    if ($(this).hasClass('slick-slider')) {
      $(this).slick('unslick');
    }
  })

  if ($('.compare-slider').hasClass('slick-slider')) {
    $('.compare-slider').slick('unslick');
  }
  if( type != 'accessories'){
    compareSlider();
  }
  if( type == 'standing-desks'){
    tabletopsSliders();
  }
  testimonialsSlider();
  if( type = 'accessories'){
    mobileSliders();
  }
};
$('body').on('click', '.header.tabs-wrapper .tab-link', function(e) {
             e.preventDefault();
  var type = $(this).attr('data-target');
  $('.page-block').removeClass('active');
  $('.page-block[data-target="'+ $(this).attr('data-target') +'"]').addClass('active');
  $('.header.tabs-wrapper').find('.tab-link').removeClass('active');
  $(this).addClass('active');
  checkSliders(type);
  var location = window.location.href.split('?')[0];
  window.history.replaceState({}, '', location + '?type=' + $(this).attr('data-target'));
  // var redirect_location = $('.site-redirect-dropdown .selector-item').data('url').split('?')[0];
  // $('.site-redirect-dropdown .selector-item').attr('data-url', redirect_location + '?type=' + $(this).attr('data-target'));
  scrollToSection($(this).attr('data-target'));

});

function activeTab() {
  if(location.href.indexOf('?') > -1){
    var type = window.location.href.split('?type=')[1];

    if(!type) {
      type =  $('.page-block').first().attr('data-target');
    }
    $('.page-block').removeClass('active');
    $('.page-block[data-target="'+ type +'"]').addClass('active');
    $('.header.tabs-wrapper').find('.tab-link').removeClass('active');
    $('.header.tabs-wrapper .tab-link[data-target="' + type + '"]').addClass('active');
    checkSliders(type);
    setTimeout(function() {
      scrollToSection(type);
    }, 800);
  }
};

$(window).on("scroll", function() {
  var $window = $(this);
  if($window.width() >= 768) {
    var sectionTabs = $('.header.tabs-wrapper');
    var windowTop = $window.scrollTop() + $('.header-wrapper').height();

    if (windowTop > sectionTabs.parent().offset().top) {
      $(".tabs-placeholder").height(sectionTabs.outerHeight());
      sectionTabs.addClass('tabs-sticky');
    } else {
      sectionTabs.removeClass('tabs-sticky');
      $(".tabs-placeholder").height(0);
    }
  }
});


function scrollToSection(type){
  var offsetTop;
  let page_blockEl =  $('.page-block[data-target="' + type + '"]');
  if(!type) {
    page_blockEl =  $('.page-block').first();
  }
  if($(window).width() >= 1199) {
    offsetTop = page_blockEl.offset().top - $('.header.tabs-wrapper').height()  - 50;
  } else if($(window).width() >= 768) {
    offsetTop = page_blockEl.offset().top - $('.header.tabs-wrapper').height() - $('.site-header').height() - 100;
  }else{
    offsetTop = page_blockEl.offset().top - $('.site-header').height() - 150;
  }
  $('html, body').animate({
    scrollTop: offsetTop
  }, 1000);
};

$('.section-products-wrapper').on('click', '.product-image', function () {
  $('.section-products-wrapper .product-image').removeClass('active');
  $(this).addClass('active');
  var index = $(this).attr('data-index');
  $('.sd-accessories-products').find('.main-image').removeClass('active');
  $('.sd-accessories-products').find('.main-image[data-index="'+ index +'"]').addClass('active');
});

$(window).resize(function() {
  mobileSliders();
  compareSlider();
});
mobileSliders();

function mobileSliders() {
  if ($(window).width() <= 990) {
     if(!$('.slider-products-image').hasClass('slick-initialized')) {
    $('.slider-products-image').slick({
      asNavFor: '.section-image .section-image-wrapper',
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            focusOnSelect: true
          }
        }
      ]
    });
  }
   if(!$('.section-image .section-image-wrapper').hasClass('slick-initialized')) {
    $('.section-image .section-image-wrapper').slick({
      asNavFor: '.slider-products-image',
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 580,
          settings: {
            dots: true,
            arrows: true
          }
        }
      ]
    });
  }
  } else {
    if ($('.slider-products-image').hasClass('slick-slider')) {
      $('.slider-products-image').slick('unslick');
    }
    if ($('.section-image .section-image-wrapper').hasClass('slick-slider')) {
      $('.section-image .section-image-wrapper').slick('unslick');
    }
  }
}
});

addEventListener("load", (event) => {
    window.dispatchEvent(new Event('resize', { bubbles: true }));

});
